export enum AwsRegion {
  AP = 'ap-northeast-1',
  CA = 'ca-central-1',
}

// ! deprecate if/when TDS supports regions
export const DEFAULT_AWS_REGION_FOR_TDS = AwsRegion.CA;

/** one hour in seconds */
export const DEFAULT_TTL_SEC = 60 * 60;

/** max delete records per request */
export const MAX_DELETE_COUNT = 1000;
